// React imports
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// Material-UI imports

// Other imports
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
// @ts-ignore
import * as yup from 'yup';

// Absolute imports
import { getCookie } from 'utils/Cookies';

// Relative imports

type FormData = {
  password1: string;
  password2: string;
};

const schema = yup.object().shape({
  password1: yup
    .string()
    .required('Please enter a password.')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      RegExp('(.*[a-z].*)'),
      'Password must have at least 1 lower case letter',
    )
    .matches(
      RegExp('(.*[A-Z].*)'),
      'Password must have at least 1 upper case letter',
    )
    .matches(RegExp('(.*\\d.*)'), 'Password must have at least 1 number'),

  password2: yup
    .string()
    .required('Please enter a password.')
    .oneOf([yup.ref('password1'), null], 'Password do not match'),
});

export function usePasswordResetConfirmPage(token: string) {
  //Refs

  // States
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Hooks
  const form = useForm<FormData>({
    defaultValues: {
      password1: '',
      password2: '',
    },
    mode: 'onBlur',
    //@ts-ignore
    resolver: yupResolver(schema),
  });

  // Effects

  // Body code

  // Functions

  function getOnSubmit() {
    return form.handleSubmit(async (data: FormData) => {
      setErrorMessage(''); // Clear previous errors
      setIsLoading(true);
      try {
        await resetPassword(data.password1);
        form.reset();
      } catch (error) {
        // Error handling is done in resetPassword function
      } finally {
        setIsLoading(false);
      }
    });
  }

  function resetPassword(newPassword: String) {
    const requestOptions = {
      method: 'POST',
      headers: [
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', getCookie('csrftoken') || ''],
      ],
      body: JSON.stringify({
        new_password: newPassword,
        token: token,
      }),
    };

    return fetch(
      `${window.location.protocol}//${window.location.host}/api/password-change/`,
      requestOptions,
    ).then(async (res) => {
      if (res.status === 200) {
        setShowForm(false);
        setErrorMessage(''); // Clear any previous errors
      } else {
        // Log the error response for debugging
        try {
          const errorData = await res.json();
          console.warn('Password reset failed:', errorData);
        } catch (parseError) {
          console.warn(
            'Password reset failed - could not parse error response',
          );
        }

        setErrorMessage('Password reset failed. Contact support.');
        throw new Error('Password reset failed'); // Throw error to trigger catch block
      }
    });
  }

  function toggleShowPassword() {
    setShowPassword(!showPassword);
  }

  return {
    form,
    getOnSubmit,
    showForm,
    showPassword,
    toggleShowPassword,
    errorMessage,
    isLoading,
  };
}
